import './functions.js';
import axios from 'axios';
import alerts from './alerts.js';
import charts from './charts.js';
import form from './form.js';
import helpers from './helpers.js';
import modals from './modals.js';
import model_list from './model-list.js';
import tables from './tables.js';
import * as Sentry from "@sentry/browser";

window.JellyBelly = {
    alerts:        alerts,
    charts:        charts,
    confirm_modal: null,
    form:          form,
    helpers:       helpers,
    modals:        modals,
    model_list:    model_list,
    notification:  null,
    tables:        tables,
    toaster:       null,

    init: function (callback) {
        this.init_sentry();

        JellyBelly.toaster = document.querySelector('.toast-container');

        let url = new URL(window.location.href);

        window._GET = {};

        if (url.pathname) {
            window._GET._path = url.pathname.split('/').filter(Boolean);

            window._GET.controller = window._GET._path[0] ?? null;
            window._GET.id         = window._GET._path[2] ?? null;
            window._GET.view       = window._GET._path[1] ?? null;
        }

        if (typeof (callback) == 'function') {
            callback();
        }

        if (window.location.search) {
            url.searchParams.forEach((value, key) => {
                if (key.endsWith('[]')) {
                    key = key.replace('[]', '');

                    if (!window._GET[key]) {
                        window._GET[key] = [];
                    }

                    if (value) {
                        window._GET[key].push(value);
                    }
                } else {
                    window._GET[key] = value ? value : null;
                }
            });
        }

        JellyBelly.charts.init();
        JellyBelly.form.init();

        new JellyBelly.model_list;
    },

    init_sentry: () => {
        if (window.sentry_dsn) {
            Sentry.init({
                dsn:            window.sentry_dsn,
                environment:    window.sentry_env,
                integrations:   [Sentry.captureConsoleIntegration({levels: ['error']})],
                release:        window.versions.project,
                sendDefaultPii: true,
                // errors thrown by browser extensions (e.g. Grammarly) injecting into form fields, not app code
                ignoreErrors: [
                    'ApplyAlertError',
                ],
                denyUrls: [
                    /^webkit-masked-url:/,
                    /^moz-extension:\/\//,
                    /^chrome-extension:\/\//,
                ],
            });

            Sentry.setUser({
                id: window.user_id,
            });

            Sentry.setExtras({
                'JellyBelly Version': window.versions.jellybelly,
                'Project Version':    window.versions.project,
            });
        }
    },

    add_history: (url, state = {}) => {
        window.history.pushState(state, '', url);
    },

    ajax: function (uri, data, success_callback, error_callback, completed_callback) {
        if (data === null) {
            data = {};
        }

        data._GET    = window._GET;
        data._target = uri;

        return axios
            .post(
                '/ajax',
                data,
                {
                    headers: {
                        'Content-Type':     'multipart/form-data',
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }
            )
            .then(json => {
                let success_data = null;
                let status       = json.data.data !== false;
                let data         = json.data.data;

                if (!status && json.data.redirect) {
                    window.location.href = json.data.redirect;
                    return;
                }

                if (json.data.debug) {
                    console.log(json.data.debug);
                }

                if (json.status < 300) {
                    if (typeof (success_callback) == 'function') {
                        success_data = success_callback({
                            data:   data,
                            status: status,
                        });
                    }
                } else {
                    if (typeof (error_callback) == 'function') {
                        error_callback({
                            status: false,
                            data:   json
                        });
                    } else {
                        console.error('There has been a server error while processing this request.', json);
                    }
                }

                if (typeof (completed_callback) == 'function') {
                    completed_callback({
                        data: json,
                        status: true,
                        success_data: success_data,
                    });
                }

                return success_data;
            })
            .catch(error => {
                if (typeof (error.response) === 'undefined') {
                    console.warn(error);
                } else if (error.response.status === 400) {
                    if (typeof (error_callback) == 'function') {
                        error_callback(error.response.data);
                    } else {
                        console.warn(error);
                    }
                } else {
                    if (typeof (error_callback) == 'function') {
                        error_callback({
                            status: false,
                            data: error
                        });
                    } else {
                        console.warn(error);
                    }
                }
            });
    },

    callback(callback, properties) {
        let callbackName = callback;

        // Parse dot notation (e.g., "open_page.autosave")
        if (callbackName && callbackName.includes('.')) {
            let parts = callbackName.split('.');
            callback = window[parts[0]];
            for (let i = 1; i < parts.length; i++) {
                callback = callback ? callback[parts[i]] : undefined;
            }
        } else {
            callback = window[callbackName];
        }

        if (typeof callback !== 'function') {
            console.error(callbackName + ' is not a callable method.');
            return;
        }

        return callback(properties);
    },

    confirm:function(title, callback, description, type) {
        if (!JellyBelly.confirm_modal) {
            JellyBelly.confirm_modal             = JellyBelly.modals.get('confirm');
            JellyBelly.confirm_modal.description = JellyBelly.confirm_modal.body.querySelector('.description');
            JellyBelly.confirm_modal.type        = JellyBelly.confirm_modal.body.querySelector('.type');
            JellyBelly.confirm_modal.type_alert  = JellyBelly.confirm_modal.type.querySelector('.alert');
            JellyBelly.confirm_modal.type_field  = JellyBelly.confirm_modal.type.querySelector('input[name="confirmation"]');
            JellyBelly.confirm_modal.type_label  = JellyBelly.confirm_modal.type.querySelector('label[for="confirmation"]');
        }

        JellyBelly.set_hidden(JellyBelly.confirm_modal.type);
        JellyBelly.form.unset_required(JellyBelly.confirm_modal.type);
        JellyBelly.confirm_modal.type_field.value = '';

        if (type) {
            JellyBelly.form.set_required(JellyBelly.confirm_modal.type);
            JellyBelly.unset_hidden(JellyBelly.confirm_modal.type);

            JellyBelly.confirm_modal.type_label.innerHTML = 'Type "' + type + '" to confirm.';
        }

        JellyBelly.confirm_modal.description.innerHTML  = description ? description : '';
        JellyBelly.confirm_modal.close.innerHTML        = 'No';
        JellyBelly.confirm_modal.save.innerText         = 'Yes';
        JellyBelly.confirm_modal.title.innerHTML        = title;

        JellyBelly.confirm_modal.$.modal('show');

        JellyBelly.confirm_modal.close.addEventListener('click', () => {
            JellyBelly.confirm_modal.$.modal('hide');

            callback(false);

            return false;
        });

        let go = function () {
            JellyBelly.confirm_modal.$.modal('hide');

            callback(true);

            return true;
        };

        JellyBelly.confirm_modal.save.addEventListener('click', () => {
            JellyBelly.set_hidden(JellyBelly.confirm_modal.type_alert);

            if (type) {
                if (JellyBelly.confirm_modal.type_field.value === type) {
                    return go();
                } else {
                    JellyBelly.unset_hidden(JellyBelly.confirm_modal.type_alert);
                }
            } else {
                return go();
            }
        });
    },

    notify:function(title, text, color, link) {
        let colors = {
            danger:  'xmark',
            info:    'info',
            success: 'check',
            warning: 'exclamation',
        };

        document.querySelector('.notification#' + JellyBelly.notification)?.remove();

        JellyBelly.notification = 'n-' + Date.now();

        if (!color || !colors[color]) {
            color = 'info';
        }

        let tag          = link ? 'a' : 'div';
        let notification = '<' + tag + (link ? ' href="' + link + '" target="_blank"' : '') + ' class="alert alert-' + color  + ' notification" id="' + JellyBelly.notification + '">' +
            '<i class="fa-fw fal fa-2x fa-circle-' + colors[color] + '"></i>' +
            '<div class="ml-3 ms-3">' +
                '<h5>' + title + '</h5>';

        if (text) {
            notification += '<p class="mt-2">' + text + '</p>';
        }

        notification += '</div>' +
        '</' + tag + '>';

        JellyBelly.toaster.insertAdjacentHTML('afterbegin', notification);

        setTimeout(
            () => document.querySelector('.notification#' + JellyBelly.notification)?.remove(),
            5000
        );
    },

    set_hidden: function (element) {
        if (typeof element !== 'object') {
            element = document.querySelector(element);
        }

        if (element) {
            element.setAttribute('hidden', 'hidden');
        }
    },

    stream:function(uri, data, callback) {
        let token = document.querySelector('meta[name="csrf-token"]');

        data = new URLSearchParams(data);

        if (token) {
            data.append('_token', token.getAttribute('content'));
        }

        for (let key in window._GET) {
            if (typeof window._GET[key] === 'object') {
                for (let key2 in window._GET[key]) {
                    if (['_path'].indexOf(key) === -1) {
                        data.append('_GET[' + key + '][' + key2 + ']', window._GET[key][key2]);
                    }
                }
            } else if (['controller', 'view'].indexOf(key) === -1) {
                data.append('_GET[' + key + ']', window._GET[key]);
            }
        }

        let stream = new EventSource('/stream/' + uri.replace('.', '/') + '?' + data.toString());

        stream.onmessage = (e) => {
            var json = JSON.parse(e.data);

            callback(json.data, json.stop);

            if (json.stop === true) {
                stream.close();
            }
        };

        return stream;
    },

    unset_hidden:function(element) {
        if (typeof element !== 'object') {
            element = document.querySelector(element);
        }

        if (element && element.hasAttribute('hidden')) {
            element.removeAttribute('hidden');
        }
    },
};

export default window.JellyBelly;
